import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "../../App.css";
import './index.css'
import axiosInstance from '../../utilities/axiosInstance';
import { showAlert } from "../AlertPopup";
import CustomListBox from "../CustomListBox";

const CreateProject = ({projectId}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const previousRoute = location.state?.previousRoute;
    const defaultFormValues = {
        projectName: "",
        client: "",
        domain: "",
    };
    const defaultLabelFormValues = {
        name: "",
        type: "Any",
        color: "#FFFFFF",
    };
    // const projectId = location.state?.projectId ? location.state?.projectId : '';
    const labelsType = ['Any', 'Bounding Box', 'Polygon'];
    const [formData, setFormData] = useState(defaultFormValues);
    const [labelData, setLabelData] = useState(defaultLabelFormValues);
    const [clientNameError, setClientNameError] = useState(false);
    const [projectNameError, setProjectNameError] = useState(false);
    const [addLabels, setAddLabels] = useState(false);
    const [labels, setLabels] = useState([]);
    const [labelNameError, setLabelNameError] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedColorForLabel, setSelectedColorForLabel] = useState('');
    const projectNameInputRef = useRef(null);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [projectTypes , setProjectTypes] = useState([]);

    const getRandomColor = () => {
        const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
        return randomColor;
    };

    const handleLabelChange = (event) => {
        setLabelData(() => ({
            ...labelData,
            [event.target.name]: event.target.value,
        }))
        if (event.target.name == 'color') {
            setSelectedColorForLabel(event.target.value);
        }
    }

    const addLabelToArray = () => {

        if (labelData.name == '') {
            setLabelNameError(true)
            return
        }
        let labelsArray = labelData.name.split(',');
        let newLabels = [];
        for (let i = 0; i < labelsArray.length; i++) {
            let updatedLabelData = {};
            updatedLabelData.name = labelsArray[i]?.trim();
            updatedLabelData.color = labelData.color;
            updatedLabelData.type = labelData.type;
            if (selectedColorForLabel == '') {
                let color = getRandomColor();
                updatedLabelData.color = color;
            }
            if (updatedLabelData.name) {
                newLabels.push(updatedLabelData);
            }
        }

        setLabels(() => ([...labels, ...newLabels]))
        setLabelNameError(false)
        setLabelData(defaultLabelFormValues)
        setSelectedColorForLabel('');
    }

    const closeLabelForm = () => {
        setAddLabels(false)
        setLabelData(defaultLabelFormValues)
    }

    const removeLabels = (index) => {
        labels.splice(index, 1)
        setLabels(() => ([...labels]))
    }

    const isDarkColor = (color) => {
        if (color[0] === '#') {
            color = color.slice(1);
        }

        let r = parseInt(color.substring(0, 2), 16);
        let g = parseInt(color.substring(2, 4), 16);
        let b = parseInt(color.substring(4, 6), 16);

        let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

        return luminance < 128 ? 'white' : 'black';
    }

    const handleChange = (e, isProjectName) => {
        const { name, value } = e.target;
        const { selectionStart, selectionEnd } = e.target;

        if (value.length >= 40) {
            alert("You have reached max input character limit");
            return;
        }

        setFormData(prevFormData => {
            const newFormData = {
                ...prevFormData,
                [name]: value,
            };

            if (name === "projectName" && value.length > 25) {
                setProjectNameError(true);
                newFormData[name] = value.slice(0, 25);
            } else {
                setProjectNameError(false);
            }

            if (name === "client" && value.length > 25) {
                setClientNameError(true);
                newFormData[name] = value.slice(0, 25);
            } else {
                setClientNameError(false);
            }

            return newFormData;
        });

        setTimeout(() => {
            if (projectNameInputRef.current) {
                projectNameInputRef.current.setSelectionRange(selectionStart, selectionEnd);
            }
        }, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.projectName.trim().toLowerCase() === formData.client.trim().toLowerCase()) {
            showAlert("Project Name and Client Name cannot be the same.", "error");
            return;
        }
        setDisableSubmitButton(true);
        if (projectId) {
            await axiosInstance.get(`/allprojects`).then(async (response) => {
                const allProjects = response.data;
                const projectNames = allProjects.map((project) => project.project_Name);
                if (projectNames.includes(formData.projectName.replace(" ", "-")) && formData.projectName != selectedProject.project_Name) {
                    showAlert(
                        `A project with name "${formData.projectName}" already exists. Please choose a different name.`,
                        "error"
                    );
                    setDisableSubmitButton(false);
                    return;
                } else {
                    const response = await axiosInstance.post(`/update/project/${projectId}`, formData);
                    const data = response.data;

                    if (response && labels.length > 0) {
                        let payload = {
                            project_id: projectId,
                            labels: labels
                        }
                        const res = await axiosInstance.post(`/create/labels`, payload);
                    }
                    showAlert(`${data.message}`, "info");
                    setFormData(defaultFormValues);
                    setDisableSubmitButton(false);
                }
            });
        } else {
            await axiosInstance.get(`/allprojects`).then(async (response) => {
                const allProjects = response.data;
                const projectNames = allProjects.map((project) => project.project_Name);
                if (projectNames.includes(formData.projectName.replace(" ", "-"))) {
                    showAlert(
                        `A project with name "${formData.projectName}" already exists. Please choose a different name.`,
                        "error"
                    );
                    setDisableSubmitButton(false);
                    return;
                } else {
                    const response = await axiosInstance.post(`/create/project`, formData);
                    const data = response.data;
                    if (response && labels.length > 0) {
                        let payload = {
                            project_id: data.rs.insertId,
                            labels: labels
                        }
                        const res = await axiosInstance.post(`/create/labels`, payload);
                    }
                    showAlert(`${data.message}`, "success");
                    setFormData(defaultFormValues);
                    setDisableSubmitButton(false);
                }
            });
        }
        navigate(previousRoute || '/');
        //navigate(previousRoute || '/');
        // document.getElementById("create-project").reset();
    };

    const getProject = () => {
        axiosInstance
            .get(`/allprojects`, {
                params: {
                    project_ids: [projectId]
                }
            })
            .then((res) => {
                const project = res.data;
                let data = {
                    projectName: project[0].project_Name,
                    client: project[0].project_clientname,
                    domain: project[0].project_domain
                }
                setSelectedProject(project[0]);
                setFormData(data);
            })
            .catch((error) => console.error(error));
    };

    const getLabels = () => {
        axiosInstance
            .get(`/labels/${projectId}`)
            .then((res) => {
                const labels = [];

                res.data.map((label) => {
                    if (label) {
                        let labelObject = {
                            name: label.label_name,
                            type: label.label_type,
                            color: label.label_color
                        }
                        labels.push(labelObject);
                    }
                })
                setLabels(labels);
            })
            .catch((error) => console.error(error));
    };

    const getProjectTypes = () => {
        axiosInstance
            .get(`/project-types`)
            .then((res) => {
                setProjectTypes(res.data);
                console.log("project type",res.data)
            })
            .catch((error) => console.error(error));
    };

    useEffect(() => {
        if (projectId) {
            getProject();
            getLabels();
        }
    }, [projectId])

    useEffect(() => {
        if(projectTypes?.length == 0 && formData.domain == 'textAnnotation'){
            getProjectTypes();
        }
    }, [formData.domain])

    const domainOptions = [
        { label: 'Image tagging', value: 'imageTagging' },
        { label: 'Text annotation', value: 'textAnnotation' },
        { label: 'Video tagging', value: 'videoTagging' },
        { label: 'Audio tagging', value: 'audioTagging' },
    ];

    return (
        <>
            <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white">{projectId ? 'Update Project' : 'Create Project'}</h2>
            <div className=" max-w-[650px] mx-auto mt-11">
                <form
                    onSubmit={handleSubmit}
                    id="create-project"
                >
                    {/* <fieldset style={{ border: '1px solid #000', padding: '20px', width: '800px' }}> */}
                    {/* <legend>Create Project:</legend> */}
                    <div id="project_content_wrapper">
                        <div className="project_content">
                            <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                                Project Name
                            </label>
                            <input
                                type="text"
                                name="projectName"
                                value={formData.projectName}
                                onChange={(e) => handleChange(e, true)}
                                required
                                ref={projectNameInputRef}
                                className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                            ></input>
                            {projectNameError ? (
                                <>
                                    <label className="errormsg2">
                                        Max project name limit reached.
                                    </label>
                                    <br />
                                </>
                            ) : null}
                            <div className="flex gap-[22px]">
                                <div className="w-[48%]">
                                    <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                                        Client
                                    </label>
                                    <input
                                        type="text"
                                        name="client"
                                        value={formData.client}
                                        onChange={handleChange}
                                        required
                                        className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                                    ></input>
                                    {clientNameError ? (
                                        <>
                                            <label className="errormsg2">
                                                Max client name limit reached.
                                            </label>
                                            <br />
                                        </>
                                    ) : null}
                                </div>
                                <div className="w-[48%]">
                                    <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                                        Domain
                                    </label>
                                    <CustomListBox
                                        name="domain"
                                        selectedValue={formData.domain}
                                        onChange={handleChange}
                                        placeholder="Select"
                                        options={domainOptions}
                                        displayKey="label"
                                        valueKey="value"
                                    />
                                </div>
                            </div>
                                {formData.domain == 'textAnnotation' && projectTypes &&
                                <>
                                    <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                                        Project Type
                                    </label>
                                    <CustomListBox
                                        name="projectType"
                                        selectedValue={formData.projectType}
                                        onChange={handleChange}
                                        placeholder="Select"
                                        options={[
                                            { label: 'Select', value: '' },
                                            ...projectTypes.map((type) => ({
                                            label: type.type_name,
                                            value: type.type_name,
                                            })),
                                        ]}
                                        displayKey="label"
                                        valueKey="value"
                                    />
                                </>}
                        </div>
                        <div className="project_label">
                            <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                                Labels
                            </label>
                            <br />
                            <div className="labels mt-[5px] min-h-[150px] p-[10px] bg-gray-d-300 rounded-3xl flex justify-center flex-col items-center">
                                {!addLabels && <button type="button" className="bg-[#CFE4EE] w-[150px] p-[9px_0] rounded-[20px] border border-[#00B4D2]" onClick={() => setAddLabels(true)}  >
                                    Add Label
                                </button>}
                                {!addLabels &&
                                    <div className="labels_container mt-[20px]">
                                        {labels && labels.map((label, index) => (<div className="inline-block border border-[rgba(54,52,52,0.2)] p-[2px_35px_2px_10px] relative m-[0px_10px_10px_0px] h-[26px] rounded-[20px]"
                                            style={{ backgroundColor: label.color, color: isDarkColor(label.color) }}>
                                            {label.name}
                                            <span className="label_delete absolute top-[5px]" onClick={() => removeLabels(index)}>
                                                <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                    <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                                                    </path>
                                                </svg>
                                            </span>
                                        </div>))}
                                    </div>}
                                {
                                    addLabels && <div>
                                        <div className="flex gap-[10px] w-[500px] mx-auto mt-[20px] justify-center">
                                            <div>
                                                <input className="mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main w-[260px] h-[35px]"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Label Name"
                                                    value={labelData.name}
                                                    onChange={handleLabelChange}
                                                    style={{ paddingLeft: '10px' }}
                                                ></input>
                                                {labelNameError && !labelData.name && <span style={{ color: '#ff4d4f' }}>
                                                    Label name is required
                                                </span>}
                                            </div>
                                            <select className="w-[140px] h-[35px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                                                name="type"
                                                onChange={handleLabelChange}
                                                value={labelData.type}

                                            >
                                                {labelsType && labelsType.map((label, index) => (<option value={label} key={index}>{label}</option>))}
                                            </select>
                                            <div
                                                className="w-[49px] h-[35px] mt-[5px] mb-[20px] rounded-full border-[4px] border-[#cdcdcd] shadow-sm cursor-pointer relative overflow-hidden"
                                            >
                                                <input
                                                    type="color"
                                                    name="color"
                                                    value={labelData.color}
                                                    required
                                                    onChange={handleLabelChange}
                                                    className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                                                />
                                                <div
                                                    className="w-full h-full rounded-full"
                                                    style={{ backgroundColor: labelData.color }}
                                                ></div>
                                            </div>
                                        </div>
                                        <div className="flex justify-center">
                                            <button type="button" className="rounded-[20px] w-[150px] h-[40px] bg-[#50FADC] text-[#28325A]" onClick={() => addLabelToArray()}  >
                                                Continue
                                            </button>
                                            <button type="button" className="rounded-[20px] w-[150px] h-[40px] bg-[#FF5A5F] text-[#FFFFFF] ml-2" onClick={() => closeLabelForm()}  >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className="labels_container mt-[20px] max-h-[100px] overflow-auto" >
                                            {labels && labels.map((label, index) => (<div className="inline-block border border-[rgba(54,52,52,0.2)] p-[2px_35px_2px_10px] relative rounded-[20px] m-[0px_10px_10px_0px] h-[26px] rounded-[20px]"
                                                style={{ backgroundColor: label.color, color: isDarkColor(label.color) }}>
                                                {label.name}
                                                <span className="label_delete absolute top-[5px]" onClick={() => removeLabels(index)}>
                                                    <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                        <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                                                        </path>
                                                    </svg>
                                                </span>
                                            </div>))}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <button disabled={disableSubmitButton}
                            type="submit"
                            className="w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                        >
                            {projectId ? "Update" : "Add Project"}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};
export default CreateProject;
